module.exports = __webpack_public_path__ + "img/sick.e6574946.png";